<template>
    <div class="clientForm">
            <!-- area-->
        <div class="border-bottom-medium mb-2">
            <!-- form row -->
            <div class="d-flex align-items-center">
                <label>Name:</label>
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter bold" v-model="customer.name">
            </div>

            <!-- form row -->
            <div class="d-flex align-items-center mt-1 ">
                <label>Country:</label>
                <!-- <span>Portugal</span>-->
                <v-select :disabled="disabled" class="unChanged countryPicker fs-bigger" :options="getCountries" label="name" v-model="selectedCountry" placeholder="- Select country -" @input="updateCountry"></v-select>
            </div>

            <!-- form row -->
            <div class="d-flex align-items-center mt-1">
                <label>Phone:</label>
                <!-- <span class="mr-2 fs-bigger bg-lighter darker bold ml-2 text-nowrap">{{customer.dial}}</span> -->
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter" v-model="customer.phone">
            </div>

            <!-- form row -->
            <div class="d-flex align-items-center mt-1">
                <label>Hotel:</label>
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter" v-model="customer.accomodation" style="width: 40% !important;">
                <label class="text-center">Room:</label>
                <input :disabled="disabled" type="text" class="ml-1 fs-bigger bg-lighter" v-model="customer.room" style="width: 70px !important;">

            </div>

            <!-- form row -->
            <div class="d-flex align-items-center mt-1">
                <label>Email:</label>
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter" v-model="customer.email">
            </div>

            <!-- form row -->
            <div class="d-flex mt-1">
                <label>Notes:</label>
                <div class="w-100">
                    <div class="color-6 bold" v-if="reservation.note && reservation.note.length > 0"> 👇 Take a look at Notes</div>
                    <textarea :disabled="disabled" @keyup="notesInputChange" v-model="reservation.note" class="fs-bigger bg-lighter darker bold" rows="1"></textarea>
                </div>
            </div>

        </div>

        <!-- area-->
        <div class="border-bottom-medium pb-2 mb-2">
            <!-- form row -->
            <div class="d-flex">
                <label>Extras:</label>
                <div class="d-flex flexGrow1">
                    <div class="bold fs-smaller d-flex flex-column flexGrow1">
                        <span v-for="bookingComponent in bookingComponents" v-if="bookingComponent.quantity > 0" :class="{'dark':!bookingComponent.id}">{{bookingComponent.quantity}} x {{bookingComponent.component.name + ' - ' + bookingComponent.componentPrice.name}}</span>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button :disabled="disabled" class="btn secondary small" @click="toggleEditExtas">EDIT</button>
                        <button :disabled="disabled" class="btn secondary small ml-2" @click="toggleAddExtas">+ ADD EXTRAS</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- area-->
        <div class="border-bottom-medium pb-2 mb-2">
            <!-- form row -->
            <div class="d-flex">
                <label>Transport:</label>
                <div class="d-flex flexGrow1">
                    <div class="bold fs-smaller d-flex flex-column flexGrow1">
                        <!-- <span>Pickup: 10:00 Alfamar</span>
                        <span>Dropoff: 15:00 Lagoa</span> -->
                        <span v-for="transfer in transport.transfers" v-if="transfer.schedule">
                            {{(transfer.transportDirection == '1')? 'Pickup' : 'Dropoff'}}:
                            {{transfer.schedule.timeShort}}
                            {{(transfer.transportDirection == '2')? reservation.event.location + ' -' : ''}}
                            {{transfer.stop.name}}
                            {{(transfer.transportDirection == '1')? '- '+ reservation.event.location : ''}}
                        </span>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button :disabled="disabled" v-if="reservation.event.eventRoutes.length > 0" class="btn secondary small" @click="toggleEditTransport">EDIT</button>
                        <span v-else class="fs-small px-2 bold dark cursor-default">No transport available</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- area-->
        <div class="border-bottom-medium pb-2 mb-2">
            <!-- form row -->
            <div class="d-flex justify-content-between align-items-center">
                <label class="d-flex flexGrow1">Voucher code:</label>
                <input :disabled="disabled" type="text" class="w-100 px-2 py-1 text-center bg-lighter" v-model="reservation.bookingOperatorCode" style="width: 200px !important;">
            </div>
        </div>

        <!-- area-->
        <div v-if="reservation.customer.bookingQuestion" class="border-bottom-medium pb-2 mb-2">
            <!-- form row -->
            <div class="d-flexjustify-content-between align-items-center">
                <label class="d-flex  w-100 flexGrow1">{{reservation.customer.bookingQuestion}}</label>
            </div>

            <div class="dark">
                <div v-if="reservation.customer.bookingAnswer">{{reservation.customer.bookingAnswer}}</div>
                <div v-else>No answer</div>
            </div>

        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import extendedVSelect from '@/extends/vue-select'

export default {
    data: function() {
        return {
            defaultCountry: null,
            selectedCountry: null,
            updateCountryRunCounter: 0,
        }
    },
    created: function () {
        this.setDefaults()

    },
    props:{
        customer:{
            type: Object
        },
        bookingComponents:{
            type: Array
        },
        transport:{
            type: Object
        },
        reservation:{
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed:{
        ...mapGetters([
            'getCountries'
        ]),
    },
    methods: {
        setDefaults: function() {
            this.defaultCountry = this.getCountries.find(i => i.default === true);
            // this.selectedCountry = this.defaultCountry;

            if(this.customer.country){
                this.selectedCountry = this.getCountries.find(i => i.id === this.customer.country);
            } else {
                this.selectedCountry = this.defaultCountry;
            }
        },
        updateCountry: function() {
            //this counter prents the updateFlags counter from triggering
            this.updateCountryRunCounter++
            if(this.updateCountryRunCounter > 1){

                let chosen = this.getCountries.find(i => { return i.id === (this.selectedCountry.id) });

                if (chosen) {

                    if(this.customer.phone == "" || this.customer.phone.length <= 6 ){
                        this.customer.phone = '+'+chosen.dial+' '
                    }
                    this.customer.country = chosen.id
                    this.customer.dial = chosen.dial
                }
            }
        },
        toggleEditExtas: function () {
            this.eventHub.$emit('editReservation_toggleEditExtas');
        },
        toggleAddExtas: function () {
            this.eventHub.$emit('editReservation_toggleAddExtras');
        },
        toggleEditTransport: function () {
            this.eventHub.$emit('editReservation_toggleEditTransport');
        },
        notesInputChange: function () {
            this.$set(this.reservation.updateFlags, 'customer', true)
        }
    },
    components:{
        vSelect: extendedVSelect
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../../assets/scss/_utility.scss';
    // @import '../../../../assets/scss/_typography.scss';

    label{
        width: 80px;
        min-width: 80px;
    }

    input{
        padding: 0.2rem 0.45rem;
        width: 100%;

        &.clickable{
            border-color: $lightest;
            // @extend .bold;
            // @extend .fs-small;
            @extend .darker;

            &:focus,&:hover{
                // border-color: $light;
            }
        }
    }

    textarea{
        // background-color: $lighter;
        width: 100%;
        padding: 0.2rem 0.45rem;
        &:focus, &:hover{
            // border-color: $light;
        }
    }




</style>

<style lang="scss">
@import '../../../../assets/scss/_utility.scss';
.clientForm{
    .unChanged{
        .dropdown-toggle{
            // border: solid 1px $lightest !important;

            .open-indicator{
                // display: none;
                height: 14px;
            }
        }
    }

    .countryPicker{
        .dropdown-toggle{
            height: 1.6rem;
            line-height: 1rem;
            padding: 0.2rem 0;

            .vs__actions{
                top: 4px;
            }

            .selected-tag{
                height: 1rem;
                line-height: 1rem;
                margin: 0;
            }

            .form-control{
                height: 1rem !important;
                line-height: 1rem !important;

            }

        }

    }
}
</style>



// WEBPACK FOOTER //
// ClientForm.vue?de338288